import {
	FETCH_HOTEL_CONTENT_FEEDS_BEGIN,
  FETCH_HOTEL_CONTENT_FEEDS_FAILURE,
  FETCH_HOTEL_CONTENT_FEEDS_SUCCESS
} from '../actions/fetchHotelContentFeeds'

const initialState = {
	feeds: {},
	loading: false,
	error: null,
}

export default function fetchHotelContentFeedsReducers(state = initialState, action) {
	switch(action.type) {
		case FETCH_HOTEL_CONTENT_FEEDS_BEGIN:
			return {
				...state,
				loading: true,
				error: null
			}

		case FETCH_HOTEL_CONTENT_FEEDS_SUCCESS:
			return {
				...state,
				loading: false,
				error: null,
				feeds: action.payload
			}

		case FETCH_HOTEL_CONTENT_FEEDS_FAILURE:
			return {
				...state,
				loading: false,
				error: action.payload.error,
				feeds: {}
			}

		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/reducers/fetchHotelContentFeeds.js